module.exports = __webpack_public_path__ + "img/selected7-min.72838bd8.png";